module.exports = __webpack_public_path__ + "static/scroll-menu.46b30e76.png";